var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#logo-facebook';
                    var viewUrl = 'sprite.svg#view-logo-facebook';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?logo-facebook#logo-facebook';
                            viewUrl = 'sprite.svg?logo-facebook#view-logo-facebook';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 486.392 486.392',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };